import React from 'react'

const Button = ({icon, text, className, onClick, iconClassName, textClassName, rounded = false, style = {}, ...props }) => {
  return (
    <button
      onClick={onClick}
      className={`flex px-4 py-2 text-sm gap-2 text-custom-gray items-center transition-colors duration-200 ${rounded ? 'rounded-full' : 'rounded-md'} ${className}`}
      style={style}
      {...props}
    >
      {icon && (
        <span className={iconClassName}>{React.isValidElement(icon) ? icon : <img src={icon} alt="icon" />}</span>
      )}
      {text && (
        <span className={textClassName}>{text}</span>
      )}
    </button>
  )
}

export default Button